import React, { ReactElement } from 'react';
import { Link } from 'react-router-dom';
import { pathToRegexp } from 'path-to-regexp';
import { urlToList } from './utils/pathTools';
import { RouterType } from './type';

interface IBreadcrumbNameMapType {
  [index: string]: {
    url: string;
    title: string;
    icon: string;
    component: ReactElement;
  };
}

interface IBreadcrumbNameType {
  url: string;
  title: string;
  icon: string;
  component: ReactElement;
}

interface IRouterLocationType {
  pathname: string;
  path: string;
  key: string;
}
// 渲染Breadcrumb 子节点
// Render the Breadcrumb child node
const itemRender = (route: RouterType, routes: RouterType[], paths: string[]) => {
    const last = routes.indexOf(route) === routes.length - 1;
    // if path is home, use Link。
    if (route.url === '/') {
        return <Link to={paths.join('/')}>{route.title}</Link>;
    }
    return last || !route.component ? (
        <span>{route.title}</span>
    ) : (
        <Link to={paths.join('/')}>{route.title}</Link>
    );
};

export const getBreadcrumbProps = (props: any) => {
    const { routes, params, location, breadcrumbNameMap } = props;
    return {
        routes,
        params,
        location: location,
        breadcrumbNameMap,
    };
};

const renderItemLocal = (item: IBreadcrumbNameType) => {
    return item.title;
};

const renderItemComponent = (item: IBreadcrumbNameType) => {
    return item.component ? true : false;
};

export const getBreadcrumb = (
    breadcrumbNameMap: IBreadcrumbNameMapType,
    url: string,
): IBreadcrumbNameType => {
    let breadcrumb = breadcrumbNameMap[url];
    if (!breadcrumb) {
        Object.keys(breadcrumbNameMap).forEach(item => {
            if (pathToRegexp(item).test(url)) {
                breadcrumb = breadcrumbNameMap[item];
            }
        });
    }
    return breadcrumb || {};
};

/* eslint-disable*/
const conversionFromLocation = (
	routerLocation: IRouterLocationType,
	breadcrumbNameMap: IBreadcrumbNameMapType,
	props: any,
) => {
	const { home } = props;
	// Convert the url to an array
	const pathSnippets = urlToList(routerLocation.pathname);
	// Loop data mosaic routing
	const extraBreadcrumbItems = pathSnippets
		.map((url: string) => {
			const currentBreadcrumb = getBreadcrumb(breadcrumbNameMap, url);
			const title = renderItemLocal(currentBreadcrumb);
			const hasComponent = renderItemComponent(currentBreadcrumb);
			return {
				path: url,
				hasComponent: hasComponent,
				breadcrumbName: title,
			};
		})
		.filter(item => item !== null);

	// Add home breadcrumbs to your head if defined
	if (home) {
		extraBreadcrumbItems.unshift({
			path: '/',
			breadcrumbName: home,
			hasComponent: true,
		});
	}
	return extraBreadcrumbItems;
};

/**
 * 将参数转化为面包屑
 * Convert parameters into breadcrumbs
 */
export const conversionBreadcrumbList = (props: any) => {
	const { location, breadcrumbNameMap } = getBreadcrumbProps(props);

	// 根据 location 生成 面包屑
	// Generate breadcrumbs based on location
	if (location && location.pathname) {
		return {
			routes: conversionFromLocation(location, breadcrumbNameMap, props),
			itemRender,
		};
	}
	return {};
};
